export default __webpack_public_path__ + "static/jeffrey-headshot-6d5171fa8a279e1d14cf19600b754818.png";